// The auth provider should be a singleton. Best practice is to only have it ever instantiated once.
// Avoid creating an instance inside the component it will be recreated on each render.

import { LoginType, MsalAuthProvider } from "react-aad-msal";
import environment from "environment";

const tenantId = environment.azureTenantId;
const clientId = environment.azureClientId;

// If two providers are created on the same page it will cause authentication errors.
export const azureAuthProvider = new MsalAuthProvider(
	{
		auth: {
			authority: "https://login.microsoftonline.com/" + tenantId,
			clientId: clientId,
			postLogoutRedirectUri: window.location.origin,
			redirectUri: window.location.origin + "/callback",
			validateAuthority: true,

			// After being redirected to the "redirectUri" page, should user
			// be redirected back to the Url where their login originated from?
			navigateToLoginRequestUrl: false,
		},
		cache: {
			cacheLocation: "localStorage",
			storeAuthStateInCookie: false,
		},
	},
	{
		scopes: ["openid profile"],
	},
	{
		loginType: LoginType.Redirect,
		// When a token is refreshed it will be done by loading a page in an iframe.
		// Rather than reloading the same page, we can point to an empty html file which will prevent
		// site resources from being loaded twice.
		tokenRefreshUri: window.location.origin + "/auth.html",
	}
);
